// src/pages/Workflows/Execucoes/components/ExecucaoDetalhe.js
// Painel direito da Tela 3: detalhe da execução selecionada

import React from 'react';

export default function ExecucaoDetalhe({ execucao, onNovaExecucao }) {
  if (!execucao) {
    return (
      <div className="exec-detalhe-empty">
        <p>Selecione uma execução para ver os detalhes</p>
      </div>
    );
  }

  const runtimeInputs = execucao.runtime_inputs || {};
  const temInputs = Object.keys(runtimeInputs).length > 0;

  const duracaoTotal = execucao.duracao_seg != null
    ? `${execucao.duracao_seg}s`
    : execucao.concluido_em == null ? 'Em curso...' : 'N/A';

  const dataInicio = new Date(execucao.iniciado_em).toLocaleString('pt-PT');

  return (
    <div className="exec-detalhe">
      <div className="exec-detalhe-header">
        <div className="exec-detalhe-meta">
          <span className="exec-detalhe-data">{dataInicio}</span>
          <span className={`exec-detalhe-estado exec-detalhe-estado--${execucao.estado}`}>
            {execucao.estado}
          </span>
          <span className="exec-detalhe-dur">⏱ {duracaoTotal}</span>
        </div>
      </div>

      {/* Inputs usados */}
      {temInputs && (
        <div className="exec-detalhe-section">
          <div className="exec-detalhe-section-title">Inputs da Execução</div>
          <pre className="exec-detalhe-pre">{JSON.stringify(runtimeInputs, null, 2)}</pre>
        </div>
      )}

      {/* Erro global */}
      {execucao.erro_global && (
        <div className="exec-detalhe-section">
          <div className="exec-detalhe-section-title" style={{ color: '#dc2626' }}>Erro</div>
          <p className="exec-detalhe-erro">{execucao.erro_global}</p>
        </div>
      )}

      {/* Botão Nova Execução */}
      <div className="exec-detalhe-actions">
        <button className="wf-btn wf-btn-primary" onClick={onNovaExecucao}>
          ▶ Nova Execução
        </button>
      </div>
    </div>
  );
}
